const zh_Hk = {
  10000001: 'SuperEx 二週年慶典',
  10000002: '簽到領取豐厚獎勵！',
  10000003: '根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高10,000USDT獎金池',
  10000004: 'SuperEx 兩週年',
  10000005: '合約慶典賽贏取20,000USDT',
  10000006: `交易量排名賽，解鎖最高 <span style="color: #ffc72b;">10,000</span> USDT 獎金池`,
  10000007: '合約冠軍賽',
  10000008: '贏取20,000USDT獎池！',

  10000009: '請選擇',
  10000010: '發行總量',
  10000011: '區塊查詢',
  10000012: '返回',
  10000013: '下一步',
  10000014: '上一步',
  10000015: '填写信息',
  10000016: '請輸入幣種簡稱',
  10000017: '請輸入幣種全稱',
  10000018: '知道了',
  10000019: '請輸入副本標題',
  10000020: '請輸入幣種流通量',
  10000021: '完成',
  10000022: '之後，關於該交易對的統計數據您可以前往WEB端官網的自由區頁面中查看。',
  10000023: '{currency} 已上所!',
  10000024: '年',
  10000025: '月',
  10000026: '日',

  10001000: '槓桿與保證金',
  10001001: '初始保證金 = 倉位張數 * 面額 / 槓桿倍數',
  10001002: '維持保證金 = 倉位張數 * 面額 * 此層級維持保證金率 - 此層級維持保證金速算額',
  10001003: '階層{tier}',
  10001004: '持倉量(張)',
  10001005: '最高槓桿倍數',
  10001006: '維持保證金比率',
  10001007: '維持保證金速算額(USDT)',
  10001008: '* 規則更新時間:',
  10001009: '* 最大槓桿倍數為150倍的U本合約包括:',
  10001010: '* 請注意，在異常價格波動和極端市場行情下，SuperEx會採取額外的措施來維護市場穩定，包括但不限於：',
  10001011: '1. 調整最高槓桿倍數',
  10001012: '2. 調整不同層級的部位限制',
  10001013: '3. 調整不同層級的維持保證金比率',
  10001014: '選擇合約',
  10001015: '{symbol}永續',
  10001016: '包含您的多空倉位總和。',
  10001017: '持倉價值階距下可使用的最高槓桿倍數。',
  10001018: '維持保證金是根據您的持倉價值級距所對應的維持保證金率計算而來。',
  10001019: ' = 層級N-1的最大持倉量(張) * 面值 * （層級N的維持保證金率 - 層級N-1的維持保證金率）+ 層級N-1的維持保證金速算額',

  8000067: '數據統計',
  8000068: '幣種簡稱',
  8000069: '公鍊或協議',
  8000070: '合約地址或TICKER',
  8000071: '副本標題',
  8000072: '副本建立時間',
  8000073: '副本狀態',
  8000074: '累計分紅金額/U',
  8000075: '上週分紅金額/U',
  8000076: '上週交易金額/U',
  8000077: '上周交易笔数',
  8000078: '創建交易對',
  8000079: '延期',
  8000080: '已上架',
  8000081: '即將下架',
  8000082: '已下架',
  8000083: '確認幣種',
  8000084: '上幣提示',
  8000085: '創建成功',
  8000086: '自由區上幣',
  8000087: '在SuperEx，您可以輕鬆又免費地完成交易所上市，並有機會獲得最高80%的交易手續費分紅。',
  8000088: '如何上幣？',
  8000089: '建立新的交易對',
  8000090: '我要上幣',
  8000091: '建立交易對副本',
  8000092: 'SuperEx交易所',
  8000093: '為何選擇我們?',
  8000094: '多樣選擇',
  8000095: '支援多鏈和協議，包括BSC鏈，ETH鏈，SOL鏈。',
  8000096: '無需人工審核，即刻上幣，感受去中心化般的上幣流程和訂單簿下單的便利性。',
  8000097: '支援API',
  8000098: '您可以通過API接口來進行做市或交易，這使您的操作更加高效和自動化。',
  8000099: '平台曝光',
  8000100: '在現貨自由區上幣，享受SuperEx的千萬用戶流量並獲得更多關注。',
  8000101: '無論您是新手還是經驗豐富的交易者，我們的現貨自由區都將為您帶來新的體驗和投資機會。立即建立屬於您自己的交易對，推廣您心愛的幣並享受交易手續費的分紅收益！',
  8000102: '您的總資產折合需要大於{resultData}U後，才有資格建立交易對',
  8000103: '上交易所',
  8000104: '您可以選擇自己喜歡的幣種，並與USDT組合成交易對，從而創造出獨特的交易品種。',
  8000105: '獲得手續費分紅',
  8000106: '當您建立的交易對副本的交易金額達到一定門檻後，一部分交易手續費將作為分紅回饋給您。這樣就讓作為交易對副本創作者的您也能分享交易收益。',
  8000107: '您目前是被限制用戶，暫時無法建立新交易對，請明天再試',
  8000108: '請選擇語言',
  8000109: '白皮書',
  8000110: '該幣種已被禁止上架！',
  8000111: '該幣種已經在SuperEx主板交易區中存在，無法再建立交易對！',
  8000112: '請輸入有效的合約地址/Ticker',
  8000113: '您的現貨主板區ET餘額不足，創建新交易對需要支付{num}ET管理費用，請充值後再來。',
  8000114: '您今天創建新幣的過程中錯誤輸入的次數太多，因此今天您不能再進行創建新幣的申請，請明天再試。',
  8000115: '該幣種已存在，現在將創建您的交易對副本！',
  8000116: '請確認以下資訊：',
  8000117: '幣種數量的小數位長度',
  8000118: '如何自由上幣',
  8000119: '幣種全稱',
  8000120: '幣種價格的小數位長度',
  8000121: 'SUPEREX上幣：<em class="normal" style="color: #0CAA6D;">0上幣費用！</em><em class="normal" style="color: #1D90F5;">0溝通成本！</em>1分鐘即可完成交易所上市，還可享受最高<em class="normal" style="color: #F65D62;">80%的收益分紅</em>',
  8000122: '英文幣種簡介',
  8000123: '以下為必填資訊：',
  8000124: '你輸入的副本標題已存在，請重新輸入！',
  8000125: '以下為選填資訊：',
  8000126: '請選擇主鏈或協議，以及對應的管理費',
  8000127: '第一步：複製並粘貼新幣的合約地址。',
  8000128: '請輸入合約地址/Ticker/ID',
  8000129: '確認創建',
  8000130: '您的交易對副本 {currency} 已建立成功！',
  8000131: '第二步：如果此幣種首次上交易所，您需要補充完成幾個基礎信息，如幣種簡介和上傳LOGO圖片。',
  8000132: 'BTC協議市場',
  8000133: '第三步：您只需要為您所創建的這個交易對副本命名即可。然後，上幣就完成了，該幣就可以面向公眾開放交易了。',
  8000134: '自由上幣',
  8000135: '請輸入發行總量',
  8000136: '第四步：當您的副本的每週交易額達到了一個門檻閾值後，您就會收到該副本的交易手續費分成。',
  8000137: '如果您選擇了8，則代表您的幣種價格的數值顯示精確到0.00000001。例如，BTC的價格顯示為$72186.12345678。對於大多數MEME幣，我們建議您選擇8即可。',
  8000138: '請輸入',
  8000139: '我要開始上幣了',
  8000140: '請輸入英文幣種簡介',
  8000141: '您可以把“副本”簡單理解為同一個交易對可以有多個版本，其中的一個版本就是您創建的實例。其他用戶通過副本名稱來區別這些版本。只要用戶選擇了您的副本進行交易，您就有機會獲得相應的交易手續費佣金。',
  8000142: '郵件格式不正確。',
  8000143: '請輸入區塊查詢地址',
  8000144: '幣種流通量',
  8000145: '幣種流通量限制輸入1-20位正整數',
  8000146: '幣種圖標',
  8000147: '支援png或jpg格式，大小在5 MB以內，每日僅限10次上傳',
  8000148: '幣種發行時間',
  8000149: '請選擇發行時間',
  8000150: '請輸入白皮書鏈接',
  8000151: '官方網站',
  8000152: '請輸入官網鏈接',
  8000153: '現貨自由區上幣',
  8000154: '讓您的幣種在交易所上市',
  8000155: '幣種簡稱的輸入限制為9位字符，僅支持數字、英文字母和英文符號',
  8000156: '幣種全稱的輸入限制為50位字符，僅支持數字、空格、英文字母和英文符號',
  8000157: '發行總量限制輸入1-20位正整數',
  8000158: '開頭或結尾字符不能是空格，並且不能有連續的空格。不支持“/”符號和表情符號。',
  8000159: '1. 上幣者需要自己對資訊真實性負責，並且平台有權利隨時下架幣種或交易對，平台有權利隨時調整資訊內容。',
  8000160: '2. 上幣者需要對所上幣種進行充分調查，並對其的合理、合規和合法性負責。如果平台發現幣種的智能合約有各種惡意的或傷害性的行為，會直接將其下架，並代表用戶對上幣者進行索賠。',
  8000161: '3. 上幣者或其他人如果之後想對幣種資訊做調整，需要聯絡我們的客服。',
  8000162: '4. 為了保護用戶的利益和淘汰不良幣種，上幣者創建的交易對如果不符合我們平台的成交量的要求標準，就會在約一周後的時間被通知下架。每週一的時候，平台會對不符合的交易對發出下架通知，屆時上幣者在5天內還有機會可以對其申請延遲下架。如果申請延遲下架成功，會獲得額外4週的上架觀察時間，否則就會被下架。',
  8000163: '5. 上幣者創建的交易對副本如果其交易額滿足了平台的分紅標準門檻，將會收到對應的手續費分紅。',
  8000164: '您是否願意提供一定數量的代幣用於營運活動及市場推廣，以便擴大該幣的影響力呢？',
  8000165: '6. 上幣者可以聯絡平台客服申請做市商的資格。',
  8000166: '創建',
  8000167: '即將創建交易對副本 {currency} 並於您的現貨主板區賬戶中扣除 {upFee} ET',
  8000168: '否',
  8000169: '是',
  8000170: '請輸入您的電子郵件，屆時我們的市場運營人員將與您聯繫',
  8000171: '您是否有推薦人或對接人？',
  8000172: '請輸入推薦人名稱或聯絡方式',
  8000173: '勾選此框, 表明您願意承擔所有相關風險, 並同意我們的<a id="service_href" class="pointer" style="color: #D9A31A" target="_self">《條款和條件》</a>',
  8000174: '獲得上幣的收益',
  8000175: '在交易所上幣的權利',
  8000176: '目前暫不支持該幣種上架！',
  8000177: '填寫資訊',
  8000178: '去分享',
  8000179: '已上所!',
  8000180: '自由區上幣，開啟財富自由',
  8000181: '我在SuperEx上创建了交易对{symbol}，大家赶紧冲！',
  8000182: '每筆分紅金額在週一更新數據，但實際發放過程中可能有最多3個工作日的延期情況。您可以在“錢包歷史記錄”-“其他”-“現貨主板區”下面，通過“贈送獎勵”類型來查看相關的記錄。',
  8000183: 'Twitter帳號',
  8000184: 'Telegram帳號',
  8000185: 'Discord帳號',
  8000186: '請輸入有效的推特連結！',
  8000187: '請輸入有效的電報連結！',
  8000188: '請輸入有效的Discord連結！',
  8000189: '請輸入Twitter連結',
  8000190: '請輸入Telegram連結',
  8000191: '請輸入Discord連結',
  8000192: '抱歉，該幣種的智能合約的內容或相關權限設定有較高安全風險。請嘗試使用其他幣種。',
  8000193: '抱歉，該幣種的智能合約的內容可能有潛在風險，目前無法上幣。請嘗試使用其他幣種。',
  8000194: '注意事項：',
  8000195: '您需要完成這個幣種的充值後，才能掛賣單。',
  8000196: '您需要把USDT劃轉到自由區後，才能掛買單。',
  8000197: '您需要對接API後，才能進行做市交易。',
  8000198: '與客服溝通',
  8000199: '請輸入2至9之間的一個整數',

  8100013: '官方驗證通道',
  8100014: '請輸入需要驗證的信息',
  8100015: '您可以進行如下內容的驗證',
  8100016: '僅限SUPEREX.COM官方郵件',
  8100017: '官方BD身份驗證',
  8100018: '例如：Telegram/X（Twitter）官方身份',
  8100019: 'Listing渠道驗證',
  8100020: '如果您需要簽訂合同/付款，請務必和官方BD進行確認',
  8100021: '感謝您對<a href="/" style="color: #FFC72B" class="under-line pointer">SUPEREX.COM</a>的關注，我們會儘可能保護大家的權益不受侵犯。',
  8100022: '非SuperEx官方渠道',
  8100023: 'SuperEx官方渠道',
  8100024: '您輸入的<em class="normal activeColor" style="word-break: break-word">{keyWord}</em>並非SuperEx的官方渠道。請注意您的資產安全，保護好個人信息',
  8100025: '您查詢內容中的<em class="normal activeColor" style="word-break: break-word">{keyWord}</em>為{note}',
  8100026: '安全提示',
  8100027: '· 請不要與未經驗證的賬戶交互。',
  8100028: '· 請勿將您的錢包助記詞、SuperEx綁定的郵箱、手機號碼和/或密碼告知任何人。',
  8100029: '· 如需更多幫助，請聯繫客服支持support@superex.com。',
  8100030: '收到{userName}的大紅包！',
  8100031: '開紅包',
  8100032: '還差最後一步！',
  8100033: '即刻下載SuperEx，領取好友紅包!',
  8100034: '放棄紅包',
}
export default zh_Hk



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/zh-HK.js